export const Logo = ({ dark = false, className = "h-12 sm:h-14" }) => {
  if (dark) {
    return (
      <div className="inline-block bg-ivory px-6 py-5" data-testid="brand-logo">
        <img
          src="/assets/logo-full.png"
          alt="InSight Metabolics — A Precision Metabolic & Lifestyle Clinic"
          className="h-28 w-auto"
        />
      </div>
    );
  }
  return (
    <img
      src="/assets/logo-lockup.png"
      alt="InSight Metabolics — A Precision Metabolic & Lifestyle Clinic"
      className={`${className} w-auto`}
      data-testid="brand-logo"
    />
  );
};
